import { ethers } from 'ethers';

export interface GetEventsRecursiveParams {
  contract: ethers.Contract;
  eventName: string;
  args?: any[];
  fromBlock: number;
  toBlock?: number;
}

export async function getEventsRecursive({
  contract,
  eventName,
  args = [],
  fromBlock,
  toBlock,
}: GetEventsRecursiveParams): Promise<ethers.Event[]> {
  if (toBlock == null) {
    toBlock = await contract.provider.getBlockNumber();
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const filterFactory = contract.filters[eventName] as (...a: any[]) => ethers.EventFilter;
  const filter = filterFactory(...args);

  try {
    console.log('fromBlock', fromBlock);
    console.log('toBlock', toBlock);
    return await contract.queryFilter(filter, fromBlock, toBlock);
  } catch (error: any) {
    console.log('error.message', error?.message);
    const combinedMsg = [
      error?.message,
      error?.data?.message,
      error?.error?.message,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    const isRangeError =
      combinedMsg.includes('block range too') ||
      combinedMsg.includes('range is too') ||
      combinedMsg.includes('exceed maximum block range') ||
      combinedMsg.includes('returned more than') ||
      combinedMsg.includes('request entity too large') ||
      combinedMsg.includes('you can make eth_getlogs requests with up to a') ||
      combinedMsg.includes('requested too many blocks') ||
      combinedMsg.includes('maximum is set to') ||
      combinedMsg.includes('limit is 2048') ||
      combinedMsg.includes('too many results') ||
      combinedMsg.includes('eth_getlogs');

    if (!isRangeError || fromBlock === toBlock) throw error;

    const mid = Math.floor((fromBlock + (toBlock as number)) / 2);
    const [left, right] = await Promise.all([
      getEventsRecursive({ contract, eventName, args, fromBlock, toBlock: mid }),
      getEventsRecursive({ contract, eventName, args, fromBlock: mid + 1, toBlock }),
    ]);
    return [...left, ...right];
  }
}

export function getEventsProvider(fallbackProvider: ethers.providers.Provider): ethers.providers.Provider {
  const rpcUrl = process.env.REACT_APP_RPC_URL;
  if (rpcUrl) {
    return new ethers.providers.JsonRpcProvider(rpcUrl);
  }

  return fallbackProvider;
}


